import { FC } from 'react';
import './CouponsTabLoader.scss';

const CouponsTabLoader: FC = () => {
  return (
    <div className="couponsTabSkeletonLoader">
      <div className="couponsHeader">
        <div className="sectionTitle animationLoader" />
        <div className="sectionDescription animationLoader" />
      </div>
      <div className="creatButtonLoader animationLoader" />
    </div>
  );
};

export default CouponsTabLoader;
